import { showModal } from "../react-redux-modal-provider";
import type { AccessLevel } from "./accessLevelsMap";
import accessLevelsMap from "./accessLevelsMap";

export default function handleAccess(
  accessLevel: AccessLevel,
  skipAccess: Array<AccessLevel> = [],
  permissions: Array<String>
): void {
  if (
    accessLevel === accessLevelsMap.NOT_LOGGED_IN &&
    skipAccess.indexOf(accessLevelsMap.NO_PREMIUM_ACCESS) === -1
  ) {
    showModal("RegisterModal");
  } else if (
    accessLevel === accessLevelsMap.NO_PREMIUM_ACCESS &&
    skipAccess.indexOf(accessLevelsMap.NO_PREMIUM_ACCESS) === -1
  ) {
    showModal("PremiumModal", { skipShowIfAlreadyVisible: true, permissions });
  } else if (
    accessLevel === accessLevelsMap.PREMIUM_ACCESS_EXPIRED &&
    skipAccess.indexOf(accessLevelsMap.PREMIUM_ACCESS_EXPIRED) === -1
  ) {
    showModal("PremiumModal", { skipShowIfAlreadyVisible: true, permissions });
  }
}
